<template>
  <div>
    <social-badge :brown="brown" :inverse="inverse" :large="large" name="pinterest" url="https://www.pinterest.com/weareillustrationx/" />
    <social-badge :brown="brown" :inverse="inverse" :large="large" name="facebook" :url="fblink" />
    <social-badge :brown="brown" :inverse="inverse" :large="large" name="twitter" url="https://twitter.com/_illustrationx" />
    <social-badge :brown="brown" :inverse="inverse" :large="large" name="linkedin" url="https://www.linkedin.com/company/illustration" />
    <social-badge :brown="brown" :inverse="inverse" :large="large" name="instagram" :url="iglink" />
  </div>
</template>

<script>
import SocialBadge from '@/components/buttons/SocialBadge.vue'
export default {
  components: {
    SocialBadge
  },
  props: {
    inverse: Boolean,
    brown: Boolean,
    large: Boolean,
    animation: Boolean
  },
  computed: {
    fblink() {
      if(this.animation) return 'https://www.facebook.com/weareanimationx/'
      return 'https://www.facebook.com/weareillustrationx'
    },
    iglink() {
      if(this.animation) return 'https://www.instagram.com/weareanimationx/'
      return 'https://www.instagram.com/weareillustrationx/'
    }
  }
}
</script>

<style>

</style>